<template>
  <IQOS title="Акция '-50% на напиток к круассану'">
    <div v-if="!editing">
      <p class="comment c-white pt-0">
        Период действия акции:
        {{ range.start | formatDate }} - {{ range.end | formatDate}}
      </p>
    </div>
    <div v-else>
      <p class="comment c-white pt-0">Период действия акции:</p>
      <v-date-picker
        v-model="range"
        class="promotion-period mt-3 ml-auto iqos-group-item"
        mode="range"
        locale="uk"
        is-dark
        color="green"
        v-if="editing"
      />
      <p class="comment c-white">
        Перечислите через запятую названия категорий, в которых работает акция:
        <BaseInput class="iqos-group-item" v-model="categories" :readonly="false" />
      </p>
    </div>
    <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import BlackInput from "@/components/BlackInput.vue";

import moment from "moment";

import PromotionsAPI from "@/api/promotions";

export default {
  components: {
    IQOS,
    IQOSActions,
    BlackInput,
  },
  data() {
    return {
      editing: false,

      range: {
        start: new Date(2020, 8, 1),
        end: new Date(2020, 8, 14),
      },

      categories: "",
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;

      this.fetchSettings();
    },
    onEditFinish() {
      PromotionsAPI.setDrinkDiscount(this.cafe._id, {
        range: this.range,
        categories: this.categories,
      });

      this.editing = false;
    },
    fetchSettings() {
      PromotionsAPI.getDrinkDiscount(this.cafe._id).then((data) => {
        this.range = {
          start: moment(data.settings.range.start).toDate(),
          end: moment(data.settings.range.end).toDate()
        }
        this.categories = data.settings.categories;
      });
    },
  },
  mounted() {
    this.fetchSettings();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
};
</script>

<style>
</style>